<template>
  <div class="layout-tkani-filters">
    <layout-loader v-show="loading"/>
    <div class="container">
        <slot :select="select" :filterCheck="filterCheck"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    filter: {}
  },
  data() {
    return {
      loading: false,
      select: {},
      checkbox: [],
      paramsFilter: {
        SEF_RULE:"/tkani/"
      },
      request: {},
      products: {},
      pagenation: {},
      pagecount: 0,
      productcount: 0,
      idComponent: 0,
    }
  },
  methods: {
    filterCheck() {
      this.loading = true;
      var param = "";
      var paramFirst = "filter/";

      if(this.select ){
        Object.keys(this.select).forEach(key => {
          let prop = this.filter.ITEMS.find(props => props.ID === key);
          if(prop){
            let val = prop.VALUES.find(vals => vals.CONTROL_ID === this.select[key]);
            if(val) {
              //URL_ID_NEWparam += prop.CODE.toLowerCase() + '-is-' + val.URL_ID + '/';
              var urlIdNewParam = prop.CODE.toLowerCase() + '-is-' + val.URL_ID + '/';
              param += urlIdNewParam;
            }
          }
        });
      }
      if(this.checkbox ){
        /*
        Object.keys(this.checkbox).forEach(key => {
          if( this.checkbox[key] ) {
            let prop = this.filter.ITEMS.find(props =>
                props.VALUES.find(values =>
                    values.CONTROL_ID === key
                )
            );
            if (prop) {
              let val = prop.VALUES.find(valss => valss.CONTROL_ID === key);
              //param += prop.CODE.toLowerCase() + '-is-' + val.URL_ID + '/';
              var urlIdNewParam = prop.CODE.toLowerCase() + '-is-' + val.URL_ID + '/';
              param += urlIdNewParam + '/';
            }
          }
        });
        */
      }
      if(param.length>0){
        param = paramFirst+param;//+"apply/";
      }else if(this.paramsFilter.SEF_RULE.length>0){
        //param = this.paramsFilter.SMART_FILTER_PATH;
        param = '';
      }
      //this.request.param = param;
      window.history.pushState({"reload":param.length}, '', `${this.paramsFilter.SEF_RULE}${param}`);
      window.location.reload();
      /*
      this.$axios({
        url: '/ajax/page-tkani.php',
        headers: {'Content-Type': 'application/json'},
        method: 'post',
        data: { request:this.request,paramsFilter:this.paramsFilter }
      }).then(response => {
        if (response.status == 200) {
          this.filter = response.data.filter;
          if(response.data.filter && response.data.filter.ITEMS){
            let obFilter = response.data.filter.ITEMS;
            this.select={};
            //this.checkbox={};
            obFilter.forEach((el) => {
              this.select[el.ID] = "";
              if(el.VALUES && el.VALUES.length) {
                el.VALUES.forEach((elV) => {
                  if (elV.CHECKED) {
                      this.select[el.ID] = elV.CONTROL_ID
                      //this.checkbox[elV.CONTROL_ID] = true;
                  }
                });
              }
            });
          }
          this.products = response.data.product;
          this.pagenation = response.data.pagenation;
          this.pagecount = parseInt(response.data.pagenation.NavPageCount);
          this.productcount = parseInt(response.data.pagenation.NavRecordCount);

          this.idComponent += 1;

          this.loading = false;
        }
      }).catch(e => {
        console.log('Error: ' + e)
      })
       */

    },
  },
  created(){
    let obFilter = this.filter.ITEMS;
    this.select={};
    //this.checkbox={};
    obFilter.forEach((el) => {
      this.select[el.ID] = "";
      if(el.VALUES && el.VALUES.length) {
        el.VALUES.forEach((elV) => {
          if (elV.CHECKED) {
            //if (el.CODE == "DLINA" || el.CODE == "SHIRINA") {
              this.select[el.ID] = elV.CONTROL_ID
            //} else {
            //  this.value.checkbox[elV.CONTROL_ID] = true;
            //}
          }
        });
      }
    });
  },
  components: {
    'layout-loader': () => import('@/components/layout/layout-loader'),
  },
}
</script>

<style lang="scss" scoped>
.layout-tkani-filters {
  margin-bottom: 40px;
}
.container{
  display: flex;
  align-items: center;
  gap: 5px;
  justify-content: center;
}
a {
  border: solid 1px var(--light);
  font-weight: 500;
  padding: 10px 15px;
  border-radius: 100px;
  cursor: pointer;
  transition: 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  &:hover {
    background: var(--light);
  }
  &.active {
    background: var(--color);
    color: #fff;
    border-color: var(--color);
  }
  svg {
    &.up {
      transform: rotate(180deg);
    }
  }
}
@media screen and (max-width: 767px) {
  .layout-tkani-filters {
    margin-top: -50px;
    text-align: center;
  }
  a {
    padding: 5px 10px;
    font-size: 14px;
  }
  .container {
    display: block;
    padding: 0 15px;
  }
  .container,
  .sort-wrapper,
  .categories {
    justify-content: center;
    flex-flow: wrap;
  }
  .categories {
    margin-bottom: 20px;
  }
}
</style>
